import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";

export const fetchDashboardData = createAsyncThunk(
  "dashboard",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/dashboard`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${import.meta.env.VITE_API_KEY}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw rejectWithValue((error as AxiosError)?.response?.data);
    }
  },
);

interface DashboardState {
  loading: boolean;
  data: any;
  error: string;
}

const initialState: DashboardState = {
  loading: false,
  data: null,
  error: "",
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = "";
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.data = null;
        state.error = action.error.message || "Failed to fetch dashboard data";
      });
  },
});

export default dashboardSlice.reducer;
